const SET_OFFICE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.office.data = {
      ...payload.value,
      metadata: { ...payload.metadata } || {},
    }
    state.office.lastUpdate = new Date()
  }
}

const SET_OFFICE_LOADING = (state, payload) => {
  state.office.loading = payload
}

const SET_PROFESSIONALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.professionals.data = {
      ...payload.value,
      metadata: { ...payload.metadata } || {},
    }
    state.professionals.lastUpdate = new Date()
  }
}

const SET_PROFESSIONALS_LOADING = (state, payload) => {
  state.professionals.loading = payload
}

const SET_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientsListed.data = {
      ...payload.value,
      metadata: { ...payload.metadata } || {},
    }
    state.clientsListed.lastUpdate = new Date()
  }
}

const SET_CLIENTS_LOADING = (state, payload) => {
  state.clientsListed.loading = payload
}

const SET_CLIENTS_GROUPED = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientsGrouped.data = {
      ...payload.value,
      metadata: { ...payload.metadata } || {},
    }
    state.clientsGrouped.lastUpdate = new Date()
  }
}

const SET_CLIENTS_GROUPED_LOADING = (state, payload) => {
  state.clientsGrouped.loading = payload
}

export {
  SET_OFFICE,
  SET_PROFESSIONALS,
  SET_CLIENTS,
  SET_OFFICE_LOADING,
  SET_PROFESSIONALS_LOADING,
  SET_CLIENTS_LOADING,
  SET_CLIENTS_GROUPED,
  SET_CLIENTS_GROUPED_LOADING,
}
